<template>
  <div class="area-selector" id="area-dialog">
    <!-- <pre>{{ current }}</pre> -->
    <h5 class="area-selector__location">
      <span class="area-selector__location__item" @click="handleLocationClick('province')"
        >浙江省</span
      >
      <span
        class="area-selector__location__item"
        v-if="current.city"
        @click="handleLocationClick('city')"
        ><i class="el-icon-arrow-right"></i>{{ current.city.name }}</span
      >
      <span
        class="area-selector__location__item"
        v-if="current.district"
        @click="handleLocationClick('district')"
        ><i class="el-icon-arrow-right"></i>{{ current.district.name }}</span
      >
    </h5>
    <div v-if="current.city">
      <el-radio-group class="area-selector__group" v-model="districtName">
        <el-radio-button
          class="area-selector__group__item"
          v-for="area in current.city.districtList"
          :key="area.id"
          :label="area.name"
          @click.native="handleDistrictClick(area)"
        ></el-radio-button>
      </el-radio-group>
    </div>
    <div v-else>
      <el-radio-group class="area-selector__group" v-model="cityName">
        <el-radio-button
          class="area-selector__group__item"
          v-for="area in fullAreaList"
          :key="area.id"
          :label="area.name"
          @click.native="handleCityClick(area)"
        ></el-radio-button>
      </el-radio-group>
    </div>
    <div class="area-selector__footer">
      <div class="area-selector__footer__location">
        您选择的是：浙江省
        <span v-if="current.city"
          ><i class="el-icon-arrow-right"></i>{{ current.city.name }}</span
        >
        <span v-if="current.district"
          ><i class="el-icon-arrow-right"></i>{{ current.district.name }}</span
        >
      </div>
      <div class="selector-button-box">
        <el-button class="area-selector__footer__btn" type="primary" @click="handleEnter"
          >确定</el-button
        >
        <el-button
          class="area-selector__footer__btn button-cancel"
          type="primary"
          round
          @click="handleCancel"
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      cityName: '',
      districtName: '',
      current: {}
    }
  },
  computed: {
    ...mapState('area', {
      fullAreaList: state => state.fullAreaList
    }),
    ...mapState('user', {
      cityInfo: state => state.cityInfo
    })
  },
  created() {
    this.current = { ...this.cityInfo }
  },
  mounted() {
    const loading = this.$loading({ target: '#area-dialog', fullscreen: false })
    this.getFullArea().then(() => {
      loading.close()
    })
    // 重新进入后保留城市当前选中点击态
    if (this.cityInfo.district) {
      this.cityName = this.cityInfo.city.name
      this.districtName = this.cityInfo.district.name
    }
  },
  methods: {
    handleLocationClick(areaLevel) {
      switch (areaLevel) {
        case 'province':
          this.cityName = ''
          this.districtName = ''
          this.current = { ...this.current, city: null, district: null, areaId: '' }
          // this.$store.commit('user/SET_CITY_INFO', { city: null, district: null, areaId: '' })
          break
        case 'city':
          this.districtName = ''
          this.current = { ...this.current, district: null, areaId: '' }
          // this.$store.commit('user/SET_CITY_INFO', { district: null, areaId: '' })
          break
        case 'district':
          break
      }
    },
    handleCityClick(city) {
      // this.$store.commit('user/SET_CITY_INFO', { city: city, areaId: '' })
      this.current = { ...this.current, city: city, areaId: '' }
    },
    handleDistrictClick(district) {
      // this.$store.commit('user/SET_CITY_INFO', { district: district, areaId: district.id })
      this.current = { ...this.current, district: district, areaId: district.id }
    },
    handleEnter() {
      // 点击确认后在根节点发起一个area-change事件，
      // 可用$root.$on('area-change')监听,注意$off
      this.$store.commit('user/SET_CITY_INFO', { ...this.current })
      this.$root.$emit('area-change')
      this.$emit('enter')
      this.getProductLabelList()
    },
    handleCancel() {
      this.$emit('cancel')
    },
    ...mapActions('area', ['getFullArea']),
    ...mapActions('product', ['getProductLabelList'])
  }
}
</script>
<style lang="scss" scoped>
.area-selector {
  &__location {
    text-align: left;
    margin-left: 20px;
    margin-top: 0;
    font-size: 20px;
    &__item {
      color: $main-color;
      cursor: pointer;
    }
  }
  &__group {
    @include clearfix;
    display: block;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding: 10px 0;

    /deep/ .is-active {
      .el-radio-button__inner {
        // background-color: transparent;
        color: $main-color;
        background: #fff;
        position: relative;
        &::after {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          width: 99%;
          height: 97%;
          border: 1px $main-color solid !important;
          border-radius: 4px;
          box-sizing: border-box;
        }
      }
    }

    &__item {
      float: left;
      margin-right: 5px;
      margin-bottom: 5px;
      & /deep/ .el-radio-button__inner {
        border: none !important;
        box-shadow: none !important;
      }
    }
  }

  .selector-button-box {
    display: flex;
    justify-content: flex-end;
  }

  &__footer {
    padding-left: 20px;
    text-align: left;

    &__location {
      margin: 20px 0;
    }

    &__btn {
      width: 90px;
      height: 40px;
      font-size: 16px;
    }

    .button-cancel {
      color: $main-color;
      border-color: $main-color;
      border-radius: 8px;
      background-color: transparent;

      &:hover {
        border-color: $main-color;
        background-color: #e8ecf9;
      }
    }
  }

  /deep/ .el-button {
    & + .el-button {
      margin-left: 16px;
    }
  }
}
</style>
